import React from 'react';

const Footer = props => (
  <footer className="bussiness-footer-1x">
    <div className="bussiness-footer-content ">
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <h5>{props.company.net.heading}</h5>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-md-4">
            <h5>{props.company.net.title}</h5>
            <div className="bussiness-footer-address">
              <ul>
                <li>
                  {' '}
                  <i className="fa fa-phone" />
                  Phone (editorial):{' '}
                  <a href={`tel:${props.company.net.phone.editorial}`}>{props.company.net.phone.editorial}</a>{' '}
                </li>
                <li>
                  {' '}
                  <i className="fa fa-envelope" />
                  <a href={`mailto:${props.company.net.email.editorial}`}>{props.company.net.email.editorial}</a>{' '}
                </li>
                <li>
                  {' '}
                  <i className="fa fa-map-marker" />
                  {props.company.net.address.street} <br />
                  {props.company.net.address.county} / {props.company.net.address.city} /{' '}
                  {props.company.net.address.country}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-4">
            <h5>{props.company.tv.title}</h5>
            <div className="bussiness-footer-address">
              <ul>
                <li>
                  {' '}
                  <i className="fa fa-phone" />
                  Phone (editorial):{' '}
                  <a href={`tel:${props.company.tv.phone.editorial}`}>{props.company.tv.phone.editorial}</a>{' '}
                </li>
                <li>
                  {' '}
                  <i className="fa fa-envelope" />
                  <a href={`mailto:${props.company.tv.email.editorial}`}>{props.company.tv.email.editorial}</a>{' '}
                </li>
                <li>
                  {' '}
                  <i className="fa fa-map-marker" />
                  {props.company.tv.address.street} <br />
                  {props.company.tv.address.county} / {props.company.tv.address.city} /{' '}
                  {props.company.tv.address.country}
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-4">
            <h5>{props.company.radio.title}</h5>
            <div className="bussiness-footer-address">
              <ul>
                <li>
                  {' '}
                  <i className="fa fa-phone" />
                  Phone (editorial):{' '}
                  <a href={`tel:${props.company.radio.phone.editorial}`}>{props.company.radio.phone.editorial}</a>{' '}
                </li>
                <li>
                  {' '}
                  <i className="fa fa-envelope" />
                  <a href={`mailto:${props.company.radio.email.editorial}`}>
                    {props.company.radio.email.editorial}
                  </a>{' '}
                </li>
                <li>
                  {' '}
                  <i className="fa fa-map-marker" />
                  {props.company.radio.address.street} <br />
                  {props.company.radio.address.county} / {props.company.radio.address.city} /{' '}
                  {props.company.radio.address.country}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <br />

        <div className="container">
          <div className="">
            <div className="col-md-12 footer-info">
              <div className="row">
                <div className="col-md-8">
                  <div className="footer-info-left">
                    <p>
                      <a href={props.footer.privacyLink}>{props.footer.privacy}</a> •{'  '}
                      <a href={props.footer.termsLink}>{props.footer.terms}</a>
                      {'  '}
                      • {props.footer.copyright} {props.footer.year}
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="footer-info-right">
                    <ul>
                      <li>
                        <a href="https://www.facebook.com/digitalcongo.net/">
                          {' '}
                          <i className="fa fa-facebook" />{' '}
                        </a>
                      </li>
                      <li>
                        <a href="http://twitter.com/digitalcongo/">
                          {' '}
                          <i className="fa fa-twitter" />{' '}
                        </a>
                      </li>
                      <li>
                        <a href="http://youtube.com/digitalcongonet/">
                          {' '}
                          <i className="fa fa-youtube" />{' '}
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/digitalcongo/">
                          {' '}
                          <i className="fa fa-instagram" />{' '}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js